// extracted by mini-css-extract-plugin
export default {"link":"sC-z","disabled":"tC-z"};